import { EarningRuleErrorHandleField } from 'components/earning/EarningRuleHandleError';
import { REWARD_AMOUNT_TYPE } from 'components/earning/RewardAmountInputArea';
import {
  EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE,
  EarningRuleRewardType,
  EarningRuleType,
  LanguageConfig,
} from 'config/CustomEnums';
import { validateRecurringPeriod } from 'containers/engagement/campaign/RecurringDateValidate'

// if (!isBack) {
//   const requiredFieldsConfig = [
//     [],
//     ['generalName'],
//     {
//       general_purchase: ['minSpending', 'maxSpending'],
//       gps_check_in: ['latitude', 'longitude', 'radius'],
//       birthday: ['birthStart', 'birthEnd'],
//       reward: ['rewardType', 'coupons', 'quantity', 'rewardTypeX'],
//       new_member: [],
//       member_referral: [],
//       qr_code_scanning: ['qrCodes'],
//     },
//   ];

//   const requiredFields =
//     currentStep === 2
//       ? [
//           ...requiredFieldsConfig[2][data.earningRuleType.toLowerCase()],
//           ...requiredFieldsConfig[currentStep]['reward'],
//         ]
//       : requiredFieldsConfig[currentStep];

//   requiredFields.forEach((field, index) => {
//     if (field === 'maxSpending') {
//       if (
//         data[field] &&
//         parseInt(data[field]) <= parseInt(data['minSpending'])
//       ) {
//         errorFields.push(EarningRuleErrorHandleField[field].name);
//         return;
//       }
//       return;
//     }

//     if (
//       field === 'coupons' &&
//       data['rewardType'] !== EarningRuleRewardType.coupons
//     ) {
//       return;
//     }

//     if (
//       field === 'rewardTypeX' &&
//       data['type'] !== EarningRuleType.generalPurchase
//     ) {
//       return;
//     }

//     if (
//       field === 'rewardTypeX' &&
//       data['rewardType'] !== EarningRuleRewardType.points &&
//       data['type'] === EarningRuleType.generalPurchase
//     ) {
//       return;
//     }

//     const value = currentStep === 1 ? data[LanguageConfig.english] : data;

//     if (!value[field] || value[field].length <= 0) {
//       errorFields.push(EarningRuleErrorHandleField[field].name);
//       return;
//     }

//     if (['latitude', 'longitude'].includes(field)) {
//       const dataField = data[field] + '';
//       if (dataField.split('.')[0].length > 3) {
//         errorFields.push(
//           EarningRuleErrorHandleField[`${field}Limit`].name,
//         );
//         return;
//       }
//     }
//   });

//   checked =
//     errorFields.length <= 0
//       ? CheckStatus.checkedWithSuccess
//       : CheckStatus.checkedWithFail;
// }
function firstStepValidate({ getValues, setError }) {
  const { linkedStampCampaign, type } = getValues();
  let errorMessage = '';
  if (linkedStampCampaign) {
    switch (type) {
      case EarningRuleType.newMember:
        errorMessage = 'New member does not support stamp campaign.';
        break;
      case EarningRuleType.birthday:
        errorMessage = 'Birthday does not support stamp campaign.';
        break;
      case EarningRuleType.levelUpgrade:
        errorMessage = 'Level upgrade does not support stamp campaign.';
        break;
      case EarningRuleType.fillingForm:
        errorMessage = EarningRuleErrorHandleField.linkStampCampaign.message;
        break;
      default:
        errorMessage = '';
        break;
    }
  }
  if (errorMessage) {
    setError('linkedStampCampaign', {
      type: 'manual',
      message: errorMessage,
    });

    return false;
  }
  return true;
}

function secondStepValidate({ getValues, setError }) {
  const [enGeneralName] = getValues([
    `translations.${LanguageConfig.english}.generalName`,
  ]);
  const errorList = [];
  if (
    !enGeneralName || enGeneralName.length > 200
  ) {
    errorList.push({
      name: 'generalName',
      message: EarningRuleErrorHandleField.generalName.message,
    });
  }
  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

const isEmpty = (value) => {
  return value === undefined || value === null || value === '' || isNaN(value);
};

const isEmptyOrLowerThanZero = (value) => {
  if (isEmpty(value)) {
    return true
  }
  if (value <= 0) {
    return true
  }
  return false
}

const isZero = (value) => {
  return value === 0 || value === '0';
};

function pointRewardTypeValidate(
  getValues,
  errorList,
) {
  const [
    earningType,
    quantity,
    tpeQuantity,
    rewardAmountType,
    pointTypeRewardPerXValue,
    tpeTypeRewardPerXValue,
    pointTypeRewardPerX,
    tpeTypeRewardPerX,
  ] = getValues([
    'type',
    'quantity',
    'tpeQuantity',
    'rewardAmountType',
    'pointTypeRewardPerXValue',
    'tpeTypeRewardPerXValue',
    'pointTypeRewardPerX',
    'tpeTypeRewardPerX',
  ]);
  if (earningType !== EarningRuleType.generalPurchase) {
    if (!quantity && !tpeQuantity) {
      errorList.push({
        name: 'pointReward',
        message: EarningRuleErrorHandleField['pointReward'].message,
      });
    }
    return
  }

  if (rewardAmountType === REWARD_AMOUNT_TYPE.oneOff) {
    if (isEmptyOrLowerThanZero(pointTypeRewardPerXValue) && isEmptyOrLowerThanZero(tpeTypeRewardPerXValue)) {
      errorList.push({
        name: 'tpeTypeRewardPerXValue',
        message: EarningRuleErrorHandleField['pointReward'].message,
      });
    }
    return
  }
  if (rewardAmountType === REWARD_AMOUNT_TYPE.dynamic) {
    if (
      isEmptyOrLowerThanZero(pointTypeRewardPerX)
      && isEmptyOrLowerThanZero(pointTypeRewardPerXValue)
      && isEmptyOrLowerThanZero(tpeTypeRewardPerX)
      && isEmptyOrLowerThanZero(tpeTypeRewardPerXValue)
    ) {
      errorList.push({
        name: 'dynamicTpeReward',
        message: EarningRuleErrorHandleField['pointReward'].message,
      });
      return
    }
    if (
      (isEmptyOrLowerThanZero(pointTypeRewardPerX) && !isEmptyOrLowerThanZero(pointTypeRewardPerXValue))
      || (isEmptyOrLowerThanZero(pointTypeRewardPerXValue) && !isEmptyOrLowerThanZero(pointTypeRewardPerX))
    ) {
      errorList.push({
        name: 'dynamicPointReward',
        message: EarningRuleErrorHandleField.point.message,
      });
    }
    if (
      (isEmptyOrLowerThanZero(tpeTypeRewardPerX) && !isEmptyOrLowerThanZero(tpeTypeRewardPerXValue))
      || (isEmptyOrLowerThanZero(tpeTypeRewardPerXValue) && !isEmptyOrLowerThanZero(tpeTypeRewardPerX))
    ) {
      errorList.push({
        name: 'dynamicTpeReward',
        message: EarningRuleErrorHandleField.tpe.message,
      });
    }
    return
  }
}

function couponRewardTypeValidate(
  getValues,
  errorList,
) {
  const [
    earningType,
    quantity,
    couponTemplate,
    rewardAmountType,
    couponTypeRewardPerX,
    couponTypeRewardPerXValue,
  ] = getValues([
    'type',
    'quantity',
    'coupons',
    'rewardAmountType',
    'couponTypeRewardPerX',
    'couponTypeRewardPerXValue',
  ]);
  if (!couponTemplate) {
    errorList.push({
      name: 'coupons',
      message: EarningRuleErrorHandleField['coupons'].message,
    });
  }
  if (earningType !== EarningRuleType.generalPurchase) {
    if (isEmptyOrLowerThanZero(quantity)) {
      errorList.push({
        name: 'quantity',
        message: EarningRuleErrorHandleField['quantity'].message,
      });
    }
    return;
  }

  if (rewardAmountType === REWARD_AMOUNT_TYPE.oneOff) {
    if (isEmptyOrLowerThanZero(couponTypeRewardPerXValue)) {
      errorList.push({
        name: 'couponTypeRewardPerXValue',
        message: 'Coupons fields are not filled correctly.',
      });
    }
    return
  }

  if (rewardAmountType === REWARD_AMOUNT_TYPE.dynamic) {
    if (isEmptyOrLowerThanZero(couponTypeRewardPerX) || isEmptyOrLowerThanZero(couponTypeRewardPerXValue)) {
      errorList.push({
        name: 'dynamicCouponReward',
        message: 'Coupons fields are not filled correctly.',
      });
    }
    return
  }
}

const stampRewardTypeValidate = (
  getValues,
  errorList,
) => {
  const [
    earningType,
    rewardAmountType,
    stampTypeRewardPerX,
    stampTypeRewardPerXValue,
  ] = getValues([
    'type',
    'rewardAmountType',
    'stampTypeRewardPerX',
    'stampTypeRewardPerXValue',
  ]);
  if (earningType !== EarningRuleType.generalPurchase) {
    return;
  }
  if (rewardAmountType === REWARD_AMOUNT_TYPE.oneOff) {
    if (isEmptyOrLowerThanZero(stampTypeRewardPerXValue)) {
      errorList.push({
        name: 'stampTypeRewardPerXValue',
        message: 'Stamps field is not filled correctly.',
      });
    }
    return;
  }
  if (rewardAmountType === REWARD_AMOUNT_TYPE.dynamic) {
    if (isEmptyOrLowerThanZero(stampTypeRewardPerX) || isEmptyOrLowerThanZero(stampTypeRewardPerXValue)) {
      errorList.push({
        name: 'dynamicStampReward',
        message: 'Stamps fields are not filled correctly.',
      });
    }
    return
  }
}

function recurringDateValidate({ getValues, errorList }) {
  const [
    isInBirthMonth,
    type,
    recurringDate,
  ] = getValues([
    'isInBirthMonth',
    "type",
    'recurringDate',
  ]);
  if (!recurringDate) {
    return
  }
  if (type != EarningRuleType.generalPurchase && type != EarningRuleType.birthday) {
    return
  }
  if (type == EarningRuleType.generalPurchase && !isInBirthMonth) {
    return
  }
  validateRecurringPeriod({ isActive: true, isStart: true, recurringDate, errorList })
  validateRecurringPeriod({ isActive: true, isStart: false, recurringDate, errorList })
}

function lineItemGroupsValidate({ getValues, errorList }) {
  const [
    lineItemGroups,
  ] = getValues([
    'lineItemGroups',
  ]);
  console.log("@@363", lineItemGroups)

  if (!lineItemGroups || !lineItemGroups.length) {
    return;
  };

  lineItemGroups.forEach((group, index) => {
    if (!group?.requirements || !group?.requirements?.length) {
      return;
    }

    group.requirements.forEach((requirement, subIndex) => {
      const fieldType = requirement?.fieldType;
      const formErrorId = `lineItemGroups.${index}.requirements.${subIndex}.error`;
      if ([
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.brand,
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.category,
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.subcategory,
      ].includes(fieldType)
      ) {
        if (!requirement?.data?.pk) {
          errorList.push({
            name: formErrorId,
            message: "Please select",
          });
          return;
        }
      };

      if ([
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.transactionAdditionalData,
        EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.purchasedItemAdditionalData,
      ].includes(fieldType)
      ) {
        if (
          !requirement?.data?.field?.pk
          || !requirement?.data?.value
        ) {
          errorList.push({
            name: formErrorId,
            message: "Please provide title and value",
          });
          return;
        }
      };

      if (fieldType === EARNING_RULE_LINE_ITEM_GROUP_REQUIREMENT_TYPE.sku) {
        if (!requirement?.data) {
          errorList.push({
            name: formErrorId,
            message: "Please provide one sku",
          });
          return;
        }
      };
    });
  });
}

function thirdStepValidate({ getValues, setError }) {
  const [
    type,
    linkedStampCampaign,
    rewardType,
    activeStartDate,
    activeEndDate,
    isAlwaysActivePeriod,
    requirePromotionCode,
  ] = getValues([
    'type',
    'linkedStampCampaign',
    'rewardType',
    'activeStartDate',
    'activeEndDate',
    'isAlwaysActivePeriod',
    'requirePromotionCode',
  ]);
  console.log(getValues());
  let requiredFieldsConfig = {
    general_purchase: ['executionPriority'],
    gps_check_in: ['latitude', 'longitude', 'radius', 'executionPriority'],
    birthday: ['executionPriority'],
    // reward: ['rewardType', 'coupons', 'quantity', 'rewardTypeX'],
    new_member: ['executionPriority'],
    member_referral: ['executionPriority'],
    qr_code_scanning: ['qrCodes', 'executionPriority'],
    filling_form: ['executionPriority'],
    level_upgrade: ['levelGoal', 'executionPriority'],
  };
  if (type === EarningRuleType.newMember && requirePromotionCode) {
    requiredFieldsConfig = {
      ...requiredFieldsConfig,
      new_member: [...requiredFieldsConfig?.new_member || [], "promotionCode"]
    }
  }
  const requiredFields = [
    ...requiredFieldsConfig[type.toLowerCase()],
    // ...requiredFieldsConfig['reward'],
  ];
  const errorList = [];
  requiredFields.forEach((field, index) => {
    // if (field === 'maxSpending') {
    //   if (
    //     getValues(field) &&
    //     parseInt(getValues(field)) <= parseInt(getValues('minSpending'))
    //   ) {
    //     errorList.push({
    //       name: 'maxSpending',
    //       message: EarningRuleErrorHandleField[field].message,
    //     });
    //     return;
    //   }
    //   return;
    // }

    // if (field === 'coupons' && rewardType !== EarningRuleRewardType.coupons) {
    //   return;
    // }

    if (
      !getValues(field) ||
      getValues(field).length <= 0
      // getValues(field).length <= 0 ||
      // (field === 'quantity' && getValues(field) <= 0) ||
      // (field === 'coupons' && !getValues(field).name)
    ) {
      errorList.push({
        name: field,
        message: EarningRuleErrorHandleField[field].message,
      });
      return;
    }

    if (['latitude', 'longitude'].includes(field)) {
      const dataField = getValues(field) + '';
      if (dataField.split('.')[0].length > 3) {
        errorList.push({
          name: field,
          message: EarningRuleErrorHandleField[field].message,
        });
        return;
      }
    }
  });
  if (rewardType === EarningRuleRewardType.points) {
    pointRewardTypeValidate(
      getValues,
      errorList
    );
  }
  if (rewardType === EarningRuleRewardType.coupons) {
    couponRewardTypeValidate(getValues, errorList);
  }
  if (rewardType === EarningRuleRewardType.stamps) {
    stampRewardTypeValidate(getValues, errorList);
  }
  if (
    [
      EarningRuleType.newMember,
      EarningRuleType.birthday,
      EarningRuleType.levelUpgrade,
      EarningRuleType.fillingForm,
    ].includes(type) || 
    (
      type === EarningRuleType.generalPurchase
      && !linkedStampCampaign
    )
  ) {
    if (
      !isAlwaysActivePeriod &&
      activeStartDate?.getTime() >= activeEndDate?.getTime()
    ) {
      errorList.push({
        name: 'activeEndDate',
        message: EarningRuleErrorHandleField.activeEndDate.message,
      });
    }
  }
  recurringDateValidate({ getValues, errorList })

  if (type === EarningRuleType.generalPurchase) {
    lineItemGroupsValidate({ getValues, errorList });
  };

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

export function validate({ getValues, setError, clearErrors, step, isBack }) {
  if (isBack) {
    return true;
  }
  clearErrors();
  switch (step) {
    case 0:
      const validStepOne = firstStepValidate({ getValues, setError });
      return validStepOne;
    case 1:
      const validStepTwo = secondStepValidate({ getValues, setError });
      return validStepTwo;
    case 2:
      const validStepThree = thirdStepValidate({ getValues, setError });
      return validStepThree;
    default:
      const validOne = firstStepValidate({ getValues, setError });
      const validTwo = secondStepValidate({ getValues, setError });
      const validThree = thirdStepValidate({ getValues, setError });
      return validOne && validTwo && validThree;
  }
}
